import CourseProgress from "@/components/course-progress/CourseProgress";

export default function StudentCourseProgress() {
  return <CourseProgress mode="student" />;
}
